<template>
  <div class="grid-row"
       :class="[{'active': (value && value.id === coupling.id)}, device]"
  >
    <div class="grid-col-1 grid-col">
      <div class="image-container">
        <img class="icon" :src="getFromStorage(coupling.render_image)" alt="">
        <span class="title" v-text="translate(coupling.title)"></span>
      </div>
    </div>

<!--    <div class="grid-col-2 grid-col">-->
<!--      <span class="title" v-text="coupling.article_number"></span>-->
<!--    </div>-->

    <div class="grid-col-3 grid-col">
      <span class="title" v-text="coupling.measurement_dn"></span>
    </div>

    <div class="grid-col-4 grid-col">
      <span class="title" v-text="coupling.r1"></span>
    </div>

    <div class="grid-col-5 grid-col">
      <span class="title" v-text="coupling.r1_wire_diameter"></span>
    </div>

    <div class="grid-col-6 grid-col">
      <span class="title" v-text="coupling.wire_diameter_opposite"></span>
    </div>

    <div class="grid-col-7 grid-col">
      <span class="title" v-text="coupling.wrench_measure"></span>
    </div>

    <div class="grid-col-8 grid-col">
      <span class="title" v-text="coupling.max_pressure"></span>
    </div>

    <div class="grid-col-9 grid-col">
      <button type="button"
              @click="change(coupling)"
      >
            <span v-if="value && value.id === coupling.id">
              {{ $t('hose.selected') }}
            </span>
        <span v-else>
              {{ $t('hose.select') }}
            </span>
      </button>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import { getFromStorage } from "@/helpers/backendStorage";

export default {
  name: "GridRowCouplings",

  props: {
    coupling: {
      type: Object,
    },
    value: {
      type: Object,
    }
  },

  computed: {
    ...mapGetters({
      device: 'getDevice',
    })
  },

  methods: {
    getFromStorage,
    change(newValue) {
      this.$emit('change', newValue);
      this.$emit('input', newValue);
    }
  },
}
</script>

<style scoped lang="scss">
.grid-row {
  display: grid;
  grid-template-columns: repeat(9, 2fr) 3fr;
  background-color: #F5F5F5;
  font-size: 12px;
  align-content: center;
  align-items: center !important;
  max-height: 36px;
  padding: 7px 0;
  font-family: neue-haas-grotesk-text, sans-serif;

  &.active {
    background-color: rgba(61, 176, 199, 0.25);

    .grid-col {
      button {
        background-color: #71BC29;
      }
    }

    &:nth-child(odd) {
      background-color: #EBEBEB;

      &.active {
        background-color: rgba(61, 176, 199, 0.25);
      }
    }
  }

  .grid-col {
    display: flex;
    align-items: center;
    justify-content: center;
    border-left: 3px solid #F0F0F0;
    padding: 4px 0;
    max-height: 36px;
    position: relative;

    .image-container {
      display: flex;
      flex-direction: row;
      align-items: center;
      position: absolute;
      left: 0;
      overflow-x: hidden;

      .icon {
        width: 48px;
        height: 28px;
      }

      .title {
        margin-left: 12px;
        display: block;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 220px;
      }
    }

    .title {
      display: block;
    }

    &:first-child {
      border-left: none;
    }

    button {
      background-color: #3DB0C7;
      color: white;
      font-family: neue-haas-grotesk-display, sans-serif;
      font-size: 11px;
      border-radius: 25px;
      max-width: 130px;
      width: 100%;
      border: none;
      outline: none;
      box-shadow: none;
      padding: 4px 0;
      transition: all ease 0.3s;

      &:hover {
        background-color: darken(#3DB0C7, 20%);
      }
    }
  }

  &.mobile {
    //max-width: calc(100vw - 30px);
    //overflow-y: scroll;

    .grid-col-9 {
      grid-column: 9 / 10;
    }
    .grid-col-10 {
      grid-column: 10 / 11;
    }
  }
}
</style>
